import { EntityCard } from '@/components/EntityCard';
import { characterPreviewMessages } from './characterPreview.messages';
import type { CharacterWithUrls } from 'schemas';
import { Heading2, Small, Muted } from '@/components/Typography';
import { Button } from '@/components/ui/button';
import { transformCharacterToEntityCard } from '@/pages/CharactersPage/helpers/transformCharacterToEntityCard';
import { sharedMessages } from '@/shared-messages/shared.messages';
import { LoadingSpinner } from '@/components/LoadingSpinner';

interface CharacterPreviewStepProps {
  characters: CharacterWithUrls[];
  isLoading: boolean;
  onBack: () => void;
  onNext: () => void;
}

export function CharacterPreviewStep({
  characters,
  isLoading,
  onBack,
  onNext,
}: CharacterPreviewStepProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="md" />
        <Small className="ml-3">
          {characterPreviewMessages.generatingPreview}
        </Small>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="text-center">
        <Heading2 className="mb-4">{characterPreviewMessages.title}</Heading2>
        <Muted>{characterPreviewMessages.subtitle}</Muted>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {characters.map((character) => {
          const entityProps = transformCharacterToEntityCard(character);
          return <EntityCard key={character.id} {...entityProps} />;
        })}
      </div>

      <div className="flex justify-between pt-4">
        <Button
          variant="secondary"
          onClick={onBack}
          aria-label={sharedMessages.commonButtons.back}
        >
          {sharedMessages.commonButtons.back}
        </Button>
        <Button onClick={onNext} aria-label={sharedMessages.commonButtons.next}>
          {sharedMessages.commonButtons.next}
        </Button>
      </div>
    </div>
  );
}
